import { ItemList } from 'models/InputLayoutItem';

export const regiones: ItemList[] = [
	{
		label: 'Arica y Parinacota',
		value: 'XV',
	},
	{
		label: 'Tarapacá',
		value: 'I',
	},
	{
		label: 'Antofagasta',
		value: 'II',
	},
	{
		label: 'Atacama',
		value: 'III',
	},
	{
		label: 'Coquimbo',
		value: 'IV',
	},
	{
		label: 'Valparaíso',
		value: 'V',
	},
	{
		label: 'Región del Libertador Gral. Bernardo O’Higgins',
		value: 'VI',
	},
	{
		label: 'Región del Maule',
		value: 'VII',
	},
	{
		label: 'Región del Biobío',
		value: 'VIII',
	},
	{
		label: 'Región de la Araucanía',
		value: 'IX',
	},
	{
		label: 'Región de Los Ríos',
		value: 'XIV',
	},
	{
		label: 'Región de Los Lagos',
		value: 'X',
	},
	{
		label: 'Región Aisén del Gral. Carlos Ibáñez del Campo',
		value: 'XI',
	},
	{
		label: 'Región de Magallanes y de la Antártica Chilena',
		value: 'XII',
	},
	{
		label: 'Región Metropolitana de Santiago',
		value: 'XIII',
	},
];
